import React, { useEffect, useState } from "react";
import styles from "./user-role.module.css";
import SVGIcon from "../../../../constants/SVGIcon";
import { Popconfirm } from "antd";

const UserRole = ({ onEdit, onDelete, data }) => {
  
  return (
    <div className={styles.user_role}>
      <div className={styles.user_role_top}>
        <div className={styles.user_role_top_prof_pic_and_name}>
          <span className={styles.user_role_top_prof_pic}>
            {data?.profile_picture_data ? (
              <img
                src={data?.profile_picture_data}
                alt="User Profile"
              />
            ) : (
              <SVGIcon
                name="profile-icon"
                width="25"
                height="25"
                className="anticon"
                stroke="rgba(57, 181, 74, 1)"
              />
            )}
          </span>

          <p className={styles.user_role_top_name_and_email}>
            <span className={styles.user_role_top_name}>
              {data?.metadata?.full_name}
            </span>
            <span className={styles.user_role_top_email}>
              {data?.email_address}
            </span>
          </p>
        </div>
        <div className={styles.priviledges}>
          {Array.isArray(data?.privileges) &&
            data?.privileges?.map((role, index) => {
              if (role?.can_view) {
                return (
                  <p
                    key={index}
                    className={`${styles.user_role_top_priviledge} ${
                      index >= 5 ? styles.hidden_priviledge : ""
                    }`}
                  >
                    <SVGIcon
                      name={"check-icon"}
                      width={"18"}
                      height={"18"}
                      className="anticon"
                      stroke={"rgba(57, 181, 74, 1)"}
                    />
                    <span>{role?.name}</span>
                  </p>
                );
              } else return null;
            })}
          {data?.privileges?.length > 5 && (
            <p className={styles.more}>
              +{data?.privileges?.length - 5}&nbsp;more
            </p>
          )}
        </div>
      </div>
      <div className={styles.user_role_bottom}>
        <button className={styles.user_role_edit} onClick={() => onEdit(data)}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            className="anticon"
            stroke={"#ffffff"}
          />
          <span>Edit</span>
        </button>
        <Popconfirm
          title="Are you sure to delete this user role?"
          onConfirm={() => onDelete(data)}
          okText="Yes"
          cancelText="No"
        >
          <button className={styles.user_role_delete}>
            <SVGIcon
              name={"delete"}
              width={"20"}
              height={"20"}
              className="anticon"
              stroke={"rgba(243, 17, 17, 1)"}
            />
            <span>Delete</span>
          </button>
        </Popconfirm>
      </div>
    </div>
  );
};

export default UserRole;
